import { create } from "zustand";

type HelpState = {
    phone: string;
    email: string;
    github: string;
    whatsappMessage: string;
    whatsappnumber: string

    loadInfo: () => void;

};

const prefills = {
    phone: "917632975366",
    email: "ranjanpanpura@gmail.com",
    github: "https://github.com/DevilForDevs?tab=repositories",
    whatsappMessage: "Hello, I need help with your app",
    whatsappnumber: "917632975366"
}

export const useHelpStore = create<HelpState>((set) => ({
    ...prefills,
    loadInfo: async () => {
        try {
            const res = await fetch("/getHelpInfo");
            const data = await res.json();

            if (data.status) {
                const rows = data.data;

                let updated = { ...prefills };

                rows.forEach((item: any) => {
                    switch (item.key_name) {

                        case "contact_whatsapp": {
                            // handle both formats: wa.me or plain number
                            let number = item.url;

                            if (item.url.includes("wa.me")) {
                                number = item.url.split("wa.me/")[1];
                            }

                            updated.whatsappnumber = number;
                            break;
                        }

                        case "contact_phone": {
                            let number = item.url;

                            if (item.url.startsWith("tel:")) {
                                number = item.url.replace("tel:", "");
                            }

                            // store with tel: format
                            updated.phone = `tel:+${number}`;
                            break;
                        }

                        case "contact_email":
                            // store with mailto:
                            updated.email = `mailto:${item.url}`;
                            break;

                        case "contact_github":
                            updated.github = item.url;
                            break;

                    }
                });

                set(updated);

            } else {
                console.log("No help data found");
            }

        } catch (err) {
            console.log("API error:", err);
        }
    }
}));